export const statusTraceabilityReport = {
    EM_PREENCHIMENTO: {
        codigo: 'EM_PREENCHIMENTO',
        descricao: 'Em preenchimento'
    },
    FINALIZADO: {
        codigo: 'FINALIZADO',
        descricao: 'Finalizado'
    },
    CANCELADO: {
        codigo: 'CANCELADO',
        descricao: 'Cancelado'
    }
};
